import { get } from '../client/axiosClient';
import { currencyEndpoints } from '../endpoints/currency.endpoints';
import type { ApiResponse, Currency } from '../types';

class CurrencyService {
  async getAll(): Promise<ApiResponse<Currency[]>> {
    const response = await get<any>(currencyEndpoints.list());
    const raw = response.data;
    return { success: raw?.success ?? false, message: raw?.message, data: raw?.data ?? [] };
  }
}

export const currencyService = new CurrencyService();
export default currencyService;
